import { useWishlist } from '@context/WishlistContext'
import styles from '@styles/WishlistPage.module.css'
import SocialLinks from '@components/SocialLinks'
import Navbar from '@components/Navbar'
import { Suspense, lazy } from 'react'

const ProductCard = lazy(() => import('@components/ProductCard'))

const WishlistPage = () => {
  const { wishlist, removeFromWishlist } = useWishlist()

  return (
    <div className={styles.wishlistPage}>
      <Navbar className={styles.wishlistNavbar} />
      <main className={styles.mainContent}>
        <h1 className={styles.title}>Mi Lista de Deseos</h1>
        {wishlist.length === 0 ? (
          <p className={styles.emptyMessage}>Tu lista de deseos está vacía.</p>
        ) : (
          <div className={styles.productGrid}>
            <Suspense fallback={<div>Cargando productos...</div>}>
              {wishlist.map((product) => {
                console.log(product);
                
                return (
                <ProductCard
                  key={product.id}
                  {...product}
                  active={true}
                  removeFromWishlist={removeFromWishlist}
                  isLens={product.category === 'Lentes'}
                />
              )})}
            </Suspense>
          </div>
        )}
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
    </div>
  )
}

export default WishlistPage
